module.exports = __webpack_public_path__ + "static/media/Rail.ccac513f.png";